import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import MsxIcons from '../../features/msx-icons';
import DynamicInput from '../dynamic-input';
import { PRIMARY_COLOR, SECONDARY_COLOR } from '../../color-constants';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const Label = styled.span`
  white-space: nowrap;
  font-size: ${props => props.size ? props.size : 15}px;
  font-weight: 700;
  line-height: 16px;
  ${props => props.color === 'primary' ? `
    color: ${SECONDARY_COLOR};
    color: var(--se-primary, ${SECONDARY_COLOR});
  ` : (props.color === 'white' ? `color: white;` : `
    color: ${PRIMARY_COLOR};
    color: var(--se-secondary, ${PRIMARY_COLOR});
  `)}

`;

const Icon = styled.span`
  display: inline-block;
  margin-left: 10px;
  cursor: pointer;
  text-decoration: none !important;
`;

const eventInputEditEnabledName = 'iac-input-edit-enabled';

class DynamicLabel extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      editEnabled: false,
    };
  }

  static propTypes = {
    enableEdit: PropTypes.bool,
    value: PropTypes.string,
    setValue: PropTypes.func,
    renderValue: PropTypes.func,
    validateValue: PropTypes.func,
    withCancel: PropTypes.bool,
    customInputProps: PropTypes.object,
  }

  // Close all other opened inputs
  onEditEnabled = () => {
    this.setState({ editEnabled: false });
  }

  componentDidMount = () => {
    window.addEventListener(eventInputEditEnabledName, this.onEditEnabled);
  }

  componentWillUnmount = () => {
    window.removeEventListener(eventInputEditEnabledName, this.onEditEnabled);
  }

  setValue = (value) => {
    if (!this.props.enableEdit) return;
    this.props.setValue(value);
    this.setState({ editEnabled: false });
  }

  cancel = () => {
    this.setState({ editEnabled: false });
  }

  renderValue(value) {
    const renderValueFunc = this.props.renderValue ? this.props.renderValue : v => v;
    return renderValueFunc(value);
  }

  render = () => {

    const colorProps = {
      color: (this.props.customInputProps?.color) || 'secondary'
    };

    return (
      <Container>
        {this.state.editEnabled ?
          <DynamicInput
            initialValue={this.props.value}
            validateValue={this.props.validateValue}
            setValue={this.setValue}
            withCancel={this.props.withCancel}
            cancel={this.cancel}
            customInputProps={this.props.customInputProps}
            editHintText={this.props.editHintText}
          ></DynamicInput>
          :
          <>
            <Label color={this.props.customInputProps.color} size={this.props.customInputProps.size}>{this.renderValue(this.props.value)}</Label>
            {this.props.enableEdit && (
              <Icon onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                window.dispatchEvent(new Event(eventInputEditEnabledName));
                this.setState({ editEnabled: true, });
              }}>
                <MsxIcons name="edit" size="nano" {...colorProps}></MsxIcons>
              </Icon>
            )}
          </>
        }
      </Container>
    );
  }
}

export default DynamicLabel;
